<template>
  <v-row
    class="ticket-show"
  >
    <v-col
      cols="12"
    >
      <v-card
        class="ticket-show-actions"
        elevation="2"
        outlined
        tile
      >
        <v-card-title>
          Revoke Autopay
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-if="autopay === null">
              There is no current autopay.
              {{ autopay }}
            </v-col>
            <v-col v-if="autopay && autopay.name">
              <v-card>
                <v-card-title>Autopay</v-card-title>
                <v-card-text>
                  <v-list density="compact">
                    <v-list-item
                      :title="'Autopay Name'"
                      :subtitle="autopay.name"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Type'"
                      :subtitle="'Recurring'"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Frequency'"
                      :subtitle="'Semi-Monthly'"
                      class="pl-0"
                    />
                    <v-list-item
                      v-else
                      :title="'Frequency'"
                      :subtitle="formatRecurringFrequency(autopay.recurring_frequency)"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Recurring Periods'"
                      :subtitle="autopay.recurring_periods * 2"
                      class="pl-0"
                    />
                    <v-list-item
                      v-else
                      :title="'Recurring Periods'"
                      :subtitle="autopay.recurring_periods"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Apply Dates'"
                      class="pl-0"
                    >
                      <template #subtitle>
                        {{ formatDate(autopay.apply_date) }}<br>
                        {{ formatDate(secondAutopay.apply_date) }}
                      </template>
                    </v-list-item>
                    <v-list-item
                      v-else
                      :title="'Apply Date'"
                      :subtitle="formatDate(autopay.apply_date)"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Process Date/Times'"
                      class="pl-0"
                    >
                      <template #subtitle>
                        {{ formatDateTime(autopay.process_datetime) }}<br>
                        {{ formatDateTime(secondAutopay.process_datetime) }}
                      </template>
                    </v-list-item>
                    <v-list-item
                      v-else
                      :title="'Process Date/Time'"
                      :subtitle="formatDateTime(autopay.process_datetime)"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Amount'"
                      :subtitle="'$' + autopay.amount"
                      class="pl-0"
                    />
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-if="payment">
              <v-card>
                <v-card-title>Payment</v-card-title>
                <v-card-text>
                  <v-list
                    v-if="payment"
                    density="compact"
                  >
                    <v-list-item
                      :title="'Payment Name'"
                      :subtitle="payment.info"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Payment Method'"
                      :subtitle="payment.payment_method_name"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Apply Date'"
                      :subtitle="formatDate(payment.apply_date)"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Amount'"
                      :subtitle="'$' + payment.amount"
                      class="pl-0"
                    />
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            text
            :disabled="loadingModel"
            @click="confirmModal = true"
          >
            Revoke Autopay
          </v-btn>

          <v-btn
            color="blue darken-1"
            text
            :disabled="loadingModel"
            :to="{ name: 'ticket-show', params: { id: $route.params.id } }"
          >
            Cancel
          </v-btn>
        </v-card-actions>

        <v-dialog
          v-if="autopay"
          v-model="confirmModal"
          max-width="500px"
          @click:outside="confirmModal = false"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Are you sure?</span>
            </v-card-title>

            <v-card-text>
              Clicking confirm will revoke the following
              autopay<span v-if="payment"> and reverse the
                following payment</span>:
              <v-row>
                <v-col>
                  <v-list density="compact">
                    <v-list-item
                      :title="'Autopay Name'"
                      :subtitle="autopay.name"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Type'"
                      :subtitle="'Recurring'"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Frequency'"
                      :subtitle="'Semi-Monthly'"
                      class="pl-0"
                    />
                    <v-list-item
                      v-else
                      :title="'Frequency'"
                      :subtitle="formatRecurringFrequency(autopay.recurring_frequency)"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Recurring Periods'"
                      :subtitle="autopay.recurring_periods * 2"
                      class="pl-0"
                    />
                    <v-list-item
                      v-else
                      :title="'Recurring Periods'"
                      :subtitle="autopay.recurring_periods"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Apply Dates'"
                      class="pl-0"
                    >
                      <template #subtitle>
                        {{ formatDate(autopay.apply_date) }}<br>
                        {{ formatDate(secondAutopay.apply_date) }}
                      </template>
                    </v-list-item>
                    <v-list-item
                      v-else
                      :title="'Apply Date'"
                      :subtitle="formatDate(autopay.apply_date)"
                      class="pl-0"
                    />
                    <v-list-item
                      v-if="secondAutopay"
                      :title="'Process Date/Times'"
                      class="pl-0"
                    >
                      <template #subtitle>
                        {{ formatDateTime(autopay.process_datetime) }}<br>
                        {{ formatDateTime(secondAutopay.process_datetime) }}
                      </template>
                    </v-list-item>
                    <v-list-item
                      v-else
                      :title="'Process Date/Time'"
                      :subtitle="formatDateTime(autopay.process_datetime)"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Amount'"
                      :subtitle="'$' + autopay.amount"
                      class="pl-0"
                    />
                  </v-list>
                </v-col>
                <v-col>
                  <v-list
                    v-if="payment"
                    density="compact"
                  >
                    <v-list-item
                      :title="'Payment Name'"
                      :subtitle="payment.info"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Payment Method'"
                      :subtitle="payment.payment_method_name"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Apply Date'"
                      :subtitle="formatDate(payment.apply_date)"
                      class="pl-0"
                    />
                    <v-list-item
                      :title="'Amount'"
                      :subtitle="'$' + payment.amount"
                      class="pl-0"
                    />
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <v-btn
                v-if="autopay.name && hasPermission('create ticket::revoke-autopay')"
                color="blue darken-1"
                text
                :loading="loadingModel"
                @click="revokeAutopay()"
              >
                Confirm
              </v-btn>
              <disabled-for-lack-of-role-btn
                v-else
                text="Confirm"
                permission="create ticket::revoke-autopay"
                :x-small="false"
                :text-button="true"
              />

              <v-btn
                color="blue darken-1"
                text
                @click="confirmModal = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="revokeModal"
          max-width="500px"
          @click:outside="revokeModal = false"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Autopay Revoked</span>
            </v-card-title>

            <v-card-text>
              <p>Would you like to perform another task or mark this ticket as solved?</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <v-btn
                color="blue darken-1"
                text
                @click="anotherTask()"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { DateTime } from 'luxon';
import { mapActions, mapState } from 'vuex';
import { AutopayFrequencies } from '@/services/LpConstants';
import DisabledForLackOfRoleBtn from '../DisabledForLackOfRoleBtn.vue';

export default {
  name: 'TicketRevokeAutopay',
  components: {
    DisabledForLackOfRoleBtn,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      revokeModal: false,
      confirmModal: false,
      loadingModel: false,
      autopay: null,
      secondAutopay: null,
      payment: null,
    };
  },
  computed: {
    ...mapState('loanProLoan', ['activeLoan']),
  },
  created() {
    this.getAutopay();
  },
  methods: {
    ...mapActions('notification', ['setNotification']),
    getAutopay() {
      return this.$axios
        .post('api/v1/support/ticket/autopay/find', {
          ticketId: this.$route.params.id,
          loanId: this.activeLoan.id,
        })
        .then((res) => {
          this.autopay = res.data.autopay;
          if (
            res.data.second_autopay
            && res.data.second_autopay.recurring_frequency
            === AutopayFrequencies.MONTHLY
          ) {
            this.secondAutopay = res.data.second_autopay;
          }
          this.payment = res.data.payment;
        });
    },
    revokeAutopay() {
      this.loadingModel = true;
      return this.$axios
        .post('api/v1/support/ticket/autopay/revoke', {
          ticketId: this.$route.params.id,
          loanId: this.activeLoan.id,
          autopayId: this.autopay.id,
          secondAutopayId: this.secondAutopay ? this.secondAutopay.id : undefined,
          paymentId: this.payment ? this.payment.id : undefined,
        })
        .then(() => {
          this.getAutopay();
          this.confirmModal = false;
          this.loadingModel = false;
          this.revokeModal = true;
          this.setNotification({
            message: 'The autopay was revoked successfully.',
            color: 'green',
          });
        });
    },
    anotherTask() {
      this.revokeModal = false;
      this.$router.push({
        name: 'ticket-show',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    formatDate(date) {
      return DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('EEEE, M/d/yy');
    },
    formatDateTime(dateTime) {
      return DateTime.fromSQL(dateTime).toFormat('EEEE, M/d/yy h:ss a');
    },
    formatRecurringFrequency(recurringFrequency) {
      const names = {};
      names[AutopayFrequencies.BIWEEKLY] = 'Bi-Weekly';
      names[AutopayFrequencies.MONTHLY] = 'Monthly';
      names[AutopayFrequencies.WEEKLY] = 'Weekly';
      return names[recurringFrequency];
    },
  },
};
</script>
